@if (processedValue()) {
  <app-status-pill [variant]="variant()" [dot]="true">
    {{ 'features.plan.no_warnings' | translate }}
  </app-status-pill>
}
